export const SPEED_RATING = 'Speed Rating'
export const MAX_LOAD = 'Max Load'
export const TIRE_TYPE = 'Tire type'
export const SEASONALITY = 'Seasonality'
export const RUN_FLAT = 'Run Flat'
export const MANUFACTURER_PART_NUMBER = 'Manufacturer Part Number'

export const SPECS_TO_DISPLAY = {
  'speed rating mph': SPEED_RATING,
  'load index': MAX_LOAD,
  'tire category': TIRE_TYPE,
  seasonality: SEASONALITY,
  'run-flat': RUN_FLAT,
  'manufacturer part number': MANUFACTURER_PART_NUMBER
}

export const VISIBLE_SPECS = Object.keys(SPECS_TO_DISPLAY)
